export default ({theme}) => ({
    selectedTheme: theme,
    get isDarkTheme() {
        return this.selectedTheme === 'dark';
    },
    get isLightTheme() {
        return this.selectedTheme === 'light';
    },
    get canApplyAppearanceMode() {
        const appearanceMode = document
            .querySelector('meta[name="appearance-mode"]')
            .getAttribute("content");

        return appearanceMode === "true";
    },
    setTheme(theme) {
        if (!this.canApplyAppearanceMode) {
            this.selectedTheme = 'light';

            return;
        }

        const isSystem = theme === "system";

        const isDark =
            theme === "dark" ||
            (isSystem && window.matchMedia("(prefers-color-scheme: dark)").matches);

        this.selectedTheme = isDark ? 'dark' : 'light';
    },
    init() {
        if (!this.canApplyAppearanceMode) {
            this.selectedTheme = 'light';
        }

        window.addEventListener('change-appearance-mode', (event) => {
            this.setTheme(event.detail.theme);
        });

        window.addEventListener('system-appearance-mode-changed', (event) => {
            this.setTheme(event.detail.theme);
        });
    }
})
